import { Outlet } from 'react-router-dom'

export function RootLayout() {
  return (
    <div className='h-full bg-background text-foreground'>
      <Outlet />
    </div>
  )
}

export default RootLayout
